// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__ZWAlj","footer":"ModalInfo_footer__hvd2u"};